import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class ConfirmedValidator {

  static validPatternPassword(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  static validMatchPassword(controlName: string, matchingControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName);
      const checkControl = controls.get(matchingControlName);
      if (checkControl.errors && !checkControl.errors.matching) {
        return null;
      }
      if (control.value !== checkControl.value) {
        controls.get(matchingControlName).setErrors({matching: true});
        return {matching: true};
      } else {
        return null;
      }
    };
  }
}
